import { TokenDetailsProvider } from "./context/token-details-context";
import type { USER_ROLES } from "./lib/constants";
import { AuthenticatedRoutes } from "./navigation/AuthenticatedRoutes";

interface IProps {
	userId: string;
	userRole: USER_ROLES;
}

export const AppAuthenticated = ({ userId, userRole }: IProps): JSX.Element => {
	return (
		<>
			<TokenDetailsProvider>
				<AuthenticatedRoutes userRole={userRole} userId={userId} />
			</TokenDetailsProvider>
		</>
	);
};
